<form [formGroup]="form" (ngSubmit)="submit()">
	<mat-form-field appearance="outline">
		<mat-label>Email</mat-label>
		<input matInput formControlName="email" required type="email" autocomplete="username">
	</mat-form-field>

	<app-password-field formControlName="password" autocomplete="current-password"></app-password-field>

	<div class="buttons login">
		<button color="primary" mat-flat-button [disabled]="!form.valid" aria-label="Press to login">
			Login
		</button>
	</div>

	<div class="forgot-scribe">
		<a routerLink="forgot">Forgot password?</a>
	</div>

	<div class="footer-scribe">
		Don't have an account? <a href="mailto:info@allaihealth.com">Contact Us</a>
	</div>
</form>
